import script from "./FormV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormV2.vue?vue&type=script&lang=ts&setup=true"

import "./FormV2.vue?vue&type=style&index=0&id=6c4e1583&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4e1583"]])

export default __exports__